
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[pageUrl]",
      function () {
        return require("private-next-pages/docs/[pageUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[pageUrl]"])
      });
    }
  